module.exports = __webpack_public_path__ + "static/media/path.8d9806c1.svg";